/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React, { useEffect } from "react";
import SVG from "react-inlinesvg";
import { Link, useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_helpers";
import { AEButton } from "../../../../../_emywork/components/buttons";
import { injectIntl, useIntl } from "react-intl";
import { connect, shallowEqual, useDispatch, useSelector } from "react-redux";
import * as auth from "../../../../../app/modules/Auth/_redux/authRedux";
import { AESVG } from "../../../../../_emywork/components/svg";
import { getConfig, setEmyRole, useLang } from "../../../../i18n";
import { AEShareButtons } from "../../../../../_emywork/components/AEShareButtons";
import { roles } from "../../../../../index";
import { AERole } from "../../../../../_emywork/components/AERole";
import Login from "../../../../../app/modules/Auth/pages/Login";
import { AEAvatar } from "../../../../../_emywork/components/AEAvatar";
import * as actions from "../../../../../app/pages/Dashboard/_redux/actions";
import { AECurrency } from "../../../../../_emywork/components/Currency";
import { WalletWidget } from "../../../../../app/pages/tiles/WalletWidget";
import { AELink } from "../../../../../_emywork/components/AELink";

function QuickUser_(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { authUser } = useSelector(
    ({ auth }) => ({ authUser: auth.user }),
    shallowEqual
  );
  const { notificationsStatistics, wallet } = useSelector(({ statistics }) => ({
    notificationsStatistics: statistics.notifications,
    wallet: statistics.wallet,
  }));

  const role = getConfig().role;

  const logoutClick = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");

    if (toggle) {
      toggle.click();
      setEmyRole(roles.visitor, false);
    }
    history.push("/logout");
  };

  return (
    <div
      id="kt_quick_user"
      className={`offcanvas offcanvas-right offcanvas p-10 ${
        !authUser ? "bg-light" : ""
      }`}
    >
      <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
        {authUser && (
          <h3 className="font-weight-bold m-0">
            {formatMessage({ id: "LAYOUT.PANEL.USER.TITLE" })}
            <small className="text-muted font-size-sm ml-2">
              {formatMessage(
                { id: "NOTIFICATION.COUNT" },
                { count: notificationsStatistics.total }
              )}
            </small>
          </h3>
        )}

        <a
          href="#"
          className="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i className="ki ki-close icon-xs text-muted" />
        </a>
      </div>
      <div className="offcanvas-content pr-5 mr-n5">
        {!authUser ? (
          <Login />
        ) : (
          <>
            <div className="d-flex align-items-center mt-5">
              <AEAvatar entity={authUser} size={80} className={"mr-5"}>
                <i className="symbol-badge bg-success" />
              </AEAvatar>
              <div className="d-flex flex-column">
                <a
                  href="#"
                  className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
                >
                  @{authUser.username}
                </a>
                {/*<div className="text-muted mt-1">Application Developer</div>*/}
                <div className="navi mt-2">
                  {[
                    {
                      svg: "/Communication/Active-call.svg",
                      text: authUser.phone,
                    },
                    {
                      svg: "/Communication/Mail-notification.svg",
                      text: authUser.email,
                    },
                  ].map(({ svg, text }, i) => (
                    <a key={i} href="#" className="navi-item">
                      <span className="navi-link p-0 pb-2">
                        <span className="navi-icon mr-1">
                          <AESVG size={"lg"} path={svg} variant={"primary"} />
                        </span>
                        <span className="navi-text text-muted text-hover-primary">
                          {text}
                        </span>
                      </span>
                    </a>
                  ))}
                </div>

                {/* <Link to="/logout" className="btn btn-light-primary btn-bold">
                Sign Out
              </Link> */}
                {/*<button className="btn btn-light-primary btn-bold" onClick={logoutClick}>Sign out</button>*/}
              </div>
            </div>
            <div className="separator separator-dashed mt-8 mb-5" />
            <div>
              <WalletWidget className={"bg-light-primary"} />
              <AEButton
                variant={"clean"}
                fontWeight={"bold"}
                block
                size={"lg"}
                className={"btn-text-dark-50 btn-hover-bg-light"}
              >
                <AESVG
                  variant={"primary"}
                  className={"pr-2"}
                  path={"/Shopping/Cart2.svg"}
                />
                <Link to={"/emy_coins"}>
                  {formatMessage({ id: "ADD_FUNDS" })}
                </Link>
              </AEButton>
            </div>
            <div className="separator separator-dashed mt-8 mb-5" />
            <div className={`navi navi-spacer-x-0 p-0`}>
              {[
                {
                  title: "MY_PROFILE",
                  subtitle: "OVERVIEW",
                  route_path: `/users/${authUser.username}`,
                  svg: "/General/Notification2.svg",
                },
                {
                  title: "UPDATE_MY_PROFILE",
                  subtitle: "UPDATE_MY_PROFILE.SUBTITLE",
                  route_path: `/update-profile`,
                  svg: "/General/Notification2.svg",
                },
              ].map(({ title, subtitle, route_path, svg }, index) => (
                <AELink
                  key={title}
                  to={route_path}
                  className="navi-item -d-flex -justify-content-center"
                >
                  <div className={`navi-link`}>
                    <div className="symbol symbol-40 bg-light mr-3">
                      <div className="symbol-label">
                        <AESVG path={svg} size={"md"} />
                      </div>
                    </div>
                    <div className="navi-text">
                      <div className={`font-weight-bold`}>
                        {formatMessage({ id: title })}
                      </div>
                      <div className="text-muted">
                        {formatMessage({ id: subtitle })}{" "}
                      </div>
                    </div>
                  </div>
                </AELink>
              ))}
            </div>
            <div className="separator separator-dashed my-7" />
            <div>
              <h5 className="mb-5 text-center">
                {formatMessage({ id: "SHARE_MY_PROFILE" })}
              </h5>
              <div className="text-center">
                <AEShareButtons
                  pathname={`/users/${authUser.username}`}
                  facebook
                  linkedin
                  twitter
                />
              </div>
            </div>
            <div className="separator separator-dashed my-7" />
            <div className={"text-center"}>
              <h5 className="mb-5 text-center">
                {formatMessage({ id: "QUICK_USER.CHANGE_SESSION" })}
              </h5>
              {authUser.roles
                .filter((r) => r !== role)
                .map((r) => (
                  <AEButton
                    key={r}
                    variant={"secondary"}
                    fontWeight={"bolder"}
                    onClick={(ev) => {
                      setEmyRole(r);
                    }}
                    block
                    className={"font-size-h6 px-8 py-4 my-3 mr-3"}
                  >
                    {formatMessage({ id: r })}
                    <AESVG
                      path={"/Navigation/Arrow-to-right.svg"}
                      size={"lg"}
                      className={"ml-5"}
                    />
                  </AEButton>
                ))}
              {/*<AERole accept={[roles.client, roles.client]}>*/}
              {/*  <AEButton*/}
              {/*    variant={"primary"}*/}
              {/*    round={"pill"}*/}
              {/*    fontWeight={"bolder"}*/}
              {/*    onClick={ev=>{*/}
              {/*      // console.log("compar",role === roles.provider ? roles.client : roles.provider);*/}
              {/*      // console.log("current",role);*/}
              {/*      // console.log("next",role === roles.provider ? roles.client : roles.provider);*/}
              {/*      // props.switchRole(role === roles.provider ? roles.client : roles.provider)*/}
              {/*      setEmyRole(role === roles.provider ? roles.client : roles.provider);//todo*/}
              {/*    }}*/}
              {/*    block*/}
              {/*    additionalClassName={"font-size-h6 px-8 py-4 my-3 mr-3"}*/}
              {/*  >*/}
              {/*    {formatMessage({id:'SWITCH_TO'},{to:formatMessage({id:role === roles.provider ? roles.client : roles.provider})})}*/}
              {/*    <AESVG*/}
              {/*      path={"/Navigation/Arrow-to-right.svg"}*/}
              {/*      size={"lg"}*/}
              {/*      // status={role !== roles.provider ? "primary" : "secondary"}*/}
              {/*      className={"ml-5"}*/}
              {/*    />*/}
              {/*  </AEButton>*/}
              {/*</AERole>*/}

              <AEButton
                variant={"light"}
                round={"pill"}
                fontWeight={"bolder"}
                block
                onClick={logoutClick}
                additionalClassName={"font-size-h6 px-8 py-4 my-3 mr-3"}
              >
                {formatMessage({ id: "SIGN_OUT" })}
              </AEButton>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export const QuickUser = injectIntl(
  connect(null, auth.authActions)(QuickUser_)
);
